/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsBulkOperationsReadAllFromSectionDesktopRequest,
  TChatsBulkOperationsReadAllFromSectionDesktopModel,
  IMappers,
  TChatsBulkOperationsReadAllFromSectionDesktopResponse,
  TChatsBulkOperationsReadAllFromSectionDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createChatsBulkOperationsReadAllFromSectionDesktopModel(
  parameters: TChatsBulkOperationsReadAllFromSectionDesktopRequest,
): TChatsBulkOperationsReadAllFromSectionDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/bulk-operations/read-all-from-section-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChatsBulkOperationsReadAllFromSectionDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChatsBulkOperationsReadAllFromSectionDesktopRequest;
}

export async function fetchChatsBulkOperationsReadAllFromSectionDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsBulkOperationsReadAllFromSectionDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsBulkOperationsReadAllFromSectionDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsBulkOperationsReadAllFromSectionDesktopModel(parameters),
    config,
  )) as FetchResponse<TChatsBulkOperationsReadAllFromSectionDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsBulkOperationsReadAllFromSectionDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsBulkOperationsReadAllFromSectionDesktopResponse>;
}
